@if (config && !config.showLoader) {
    <ng-container>
        <calendarmenu [showActions]="showActions"></calendarmenu>
    </ng-container>
}
